import styled from "@emotion/styled";

export const Checkbox = styled.div<{ marginBottomValue?: number }>`
  width: 100%;
  margin-bottom: ${({ marginBottomValue = "1.25rem" }) =>
    `${marginBottomValue}rem`};
  display: flex;
  justify-content: flex-start;
  align-items: center;
  cursor: pointer;
  position: relative;
  margin-left: -4px;
  margin-top: 1rem;
`;

export const Label = styled.label`
  display: flex;
  cursor: pointer;
  justify-content: flex-start;
  align-items: center;
  padding-right: 1.25rem;
  input[type="checkbox"] {
    display: none;
    position: relative;
    right: -999em;
  }
  div {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 26px;

    span {
      border: 1px solid ${(props) => props.theme.colors.secondary.base};
      width: 14px;
      height: 14px;
      display: inline-block;
    }

    :focus {
      border-radius: 50%;
      border: 1px solid;
      outline: none;
      border-color: ${(props) => props.theme.colors.secondaryOverlayDark};
      background-color: ${(props) => props.theme.colors.secondaryOverlayDark};
    }
  }

  input:checked + div {
    span {
      background-clip: content-box;
      padding: 2px;
      color: ${(props) => props.theme.colors.black};
      background-color: ${(props) => props.theme.colors.black};
    }
  }
`;

/* Adding 'disabled' to the input doesn't work so had to just hide it instead with display: none */
export const LabelHidden = styled.label`
  display: none;
  cursor: pointer;
  justify-content: flex-start;
  align-items: center;
  padding-right: 1.25rem;
  input[type="checkbox"] {
    display: none;
    position: relative;
    right: -999em;
  }
  div {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 26px;

    span {
      border: 1px solid ${(props) => props.theme.colors.secondary.base};
      width: 14px;
      height: 14px;
      display: inline-block;
    }

    :focus {
      border-radius: 50%;
      border: 1px solid;
      outline: none;
      border-color: ${(props) => props.theme.colors.secondaryOverlayDark};
      background-color: ${(props) => props.theme.colors.secondaryOverlayDark};
    }
  }

  input:checked + div {
    span {
      background-clip: content-box;
      padding: 2px;
      color: ${(props) => props.theme.colors.black};
      background-color: ${(props) => props.theme.colors.black};
    }
  }
`;
